/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const TargetIcon = /*#__PURE__*/ createSvgIcon(
  'TargetIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10.006 18a7.81 7.81 0 01-3.11-.625 8.064 8.064 0 01-2.552-1.719 8.065 8.065 0 01-1.719-2.551A7.819 7.819 0 012 9.99c0-1.104.208-2.14.625-3.105a8.066 8.066 0 014.27-4.26A7.819 7.819 0 0110.01 2a7.75 7.75 0 013.105.625 8.082 8.082 0 014.26 4.265A7.77 7.77 0 0118 9.994a7.81 7.81 0 01-.625 3.11 8.063 8.063 0 01-1.719 2.552 8.081 8.081 0 01-2.546 1.719 7.77 7.77 0 01-3.104.625zM10 16.5c1.806 0 3.34-.632 4.604-1.896C15.868 13.34 16.5 11.806 16.5 10s-.632-3.34-1.896-4.604C13.34 4.132 11.806 3.5 10 3.5s-3.34.632-4.604 1.896C4.132 6.66 3.5 8.194 3.5 10s.632 3.34 1.896 4.604C6.66 15.868 8.194 16.5 10 16.5zm0-1.5c-1.389 0-2.57-.486-3.542-1.458C5.486 12.569 5 11.389 5 10c0-1.389.486-2.57 1.458-3.542C7.431 5.486 8.611 5 10 5c1.389 0 2.57.486 3.542 1.458C14.514 7.431 15 8.611 15 10c0 1.389-.486 2.57-1.458 3.542C12.569 14.514 11.389 15 10 15zm0-1.5c.972 0 1.799-.34 2.48-1.02.68-.681 1.02-1.508 1.02-2.48s-.34-1.799-1.02-2.48C11.798 6.84 10.971 6.5 10 6.5s-1.799.34-2.48 1.02C6.84 8.202 6.5 9.029 6.5 10s.34 1.799 1.02 2.48c.681.68 1.508 1.02 2.48 1.02zm-.004-2c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 018.5 9.996c0-.414.147-.767.442-1.059a1.456 1.456 0 011.062-.437c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 01-1.062.437z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default TargetIcon;
